import { TableCellFactory } from "../../../common/tables/factory";
import {
    CostPayoutModifierTableRow
} from "../../../../../common/tables/cost-payout-modifier/CostPayoutModifierTableRow";
import { CostPayoutModifier } from "../../../../../common/models";
import { EnumResolver } from "../../../common/tables/etc/EnumResolver";
import { CPMEnumMapper } from "../etc/CPMEnumMapper";
import { FloatingMenuButtonPopoverItems } from "../../../common/FloatingMenuButton";

export interface CPMTableCellCallbacks {
    onOpenDetailSideSheet?: (cpm: CostPayoutModifier, tabIndex: number) => void;
}

export class CPMTableCellFactory extends TableCellFactory<CostPayoutModifierTableRow, CostPayoutModifier> {
    readonly enumResolver: EnumResolver<CostPayoutModifierTableRow> = new CPMEnumMapper();
    private callbacks: CPMTableCellCallbacks;

    constructor(callbacks: CPMTableCellCallbacks = {}) {
        super();
        this.callbacks = callbacks;
    }

    protected resolvePopoverCellMenuItems(rowData: CostPayoutModifier): FloatingMenuButtonPopoverItems[] {
        return [
            {
                label: "Cost Metadata",
                onSelect: () => {
                    this.callbacks.onOpenDetailSideSheet?.(rowData, 0);
                },
            },
            {
                label: "Payout Rules",
                onSelect: () => {
                    this.callbacks.onOpenDetailSideSheet?.(rowData, 1);
                },
            },
        ];
    }
}
